<template>
	<div>
		<div class="union_container">
			  <p class="sub_menu_title">中科联盟</p>
			  <div class="union_list">
				  <div class="union_box_left">
					  <div>
					  <p class="union_box_left_title">致力于提供科研共享平台</p>
					  <p class="union_box_left_title">分享科研仪器与场所</p>
					  </div>
					   <p class="union_box_left_msg">中科联盟(www.zkshare.com)旨在提供一个信息化的科研资源共享平台,为科研人员提供强大的设备平台支持,鼓励各科研单位设备开放共用和实验技术人员进驻平台提供科研服务,充分提高科研资源的利用率和使用效益加强单位之间的科研合作,鼓励科研技术与信息的交流。</p>
					   <div class="union_box_left_sum">
						   <div class="union_box_left_sum_box">
							   <p class="union_box_left_sum_title">6<sup class="union_box_left_sum_title_sup">万</sup></p>
							   <p class="union_box_left_sum_msg">用户注册</p>
						   </div>
						   <div style="width: 0.0625rem;height: 2.6875rem;background-color: #EEF0F6;margin: 0 2rem;margin-top: 1.5rem;"></div>
						   <div class="union_box_left_sum_box">
						   		<p class="union_box_left_sum_title">80<sup class="union_box_left_sum_title_sup">万</sup></p>
						   		<p class="union_box_left_sum_msg">交易量</p>
						   </div>
						   <div style="width: 0.0625rem;height: 3.9375rem;background-color: #EEF0F6;margin: 0 2rem;margin-top: 1.5rem;"></div>
						   <div class="union_box_left_sum_box">
						   		<p class="union_box_left_sum_title">85<sup class="union_box_left_sum_title_sup">%</sup></p>
						   		<p class="union_box_left_sum_msg">共享率</p>
						   </div>
					   </div>
				  </div>
				  <img class="union_box_right_img" src="../../assets/static/images/x7.png">
			  </div>
		</div>
		<div class="func_container">
			  <p class="sub_menu_title">平台功能</p>
			<div class="func_list">
				<div class="func_box_l">
					<img class="func_box_l_img" src="../../assets/static/images/x1.png">
					<p class="func_title">仪器共享</p>
					<p class="func_msg">各科研单位公开共享仪器，充分提高科研资源的利用率和使用效益加强单位之间的科研合作</p>
				</div>
				<div class="func_box_m">
					<div class="func_box_m_detail">
						<img class="func_box_m_img" src="../../assets/static/images/x2.png">
						<div>
							<p class="func_title">试剂耗材</p>
							<p class="func_msg">实验中使用的试剂耗材，平台相对应提供并明码标价</p>
						</div>
					</div>
					<div class="func_box_m_detail">
						<img class="func_box_m_img" src="../../assets/static/images/x3.png">
						<div>
							<p class="func_title">技术服务</p>
							<p class="func_msg">实验结束后提供与之关联样本检测服务</p>
						</div>
					</div>
				</div>
				<div class="func_box_s">
					<div class="func_box_s_detail">
						<img class="func_box_s_img" src="../../assets/static/images/x4.png">
						<div>
							<p class="func_title">翻译润色</p>
							<p class="func_msg">提供中外语专业医学论文翻译网站</p>
						</div>
					</div>
					<div class="func_box_s_detail">
						<img class="func_box_s_img" src="../../assets/static/images/x5.png">
						<div>
							<p class="func_title">细胞库</p>
							<p class="func_msg">提供实验室中所需的细胞</p>
						</div>
					</div>
					<div class="func_box_s_detail">
						<img class="func_box_s_img" src="../../assets/static/images/x6.png">
						<div>
							<p class="func_title">病原微生物报备</p>
							<p class="func_msg">实验所需病原微生物进行安全报备</p>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import { scrollAnimation } from '../../utils/js/scrollAnimation.js';
	export default {
		created(){
			const currentY = document.documentElement.scrollTop || document.body.scrollTop
			scrollAnimation(currentY, 800)
		},
	}
</script>

<style lang="less" scoped>
	.union_container{
		padding-top: 2rem;
		.union_list{
			width: 75rem;
			margin: 0 auto;
			padding-top: 3rem;
			display: flex;
			.union_box_left{
				display: flex;
				flex-direction: column;
				width: 37.125rem;
				height: 27.5rem;
				justify-content: space-between;
				align-items: flex-start;
			}
			.union_box_right_img{
				width: 37.125rem;
				height: 27.5rem;
			}
			.union_box_left_sum{
				display: flex;
			}
			.union_box_left_title{
				font-size: 1.75rem;
				font-family: PingFangSC-Regular, PingFang SC;
				font-weight: 400;
				color: #333333;
				padding: 0;
				margin: 0;
			}
			.union_box_left_msg{
				font-size: 0.9375rem;
				font-family: PingFangSC-Regular, PingFang SC;
				font-weight: 400;
				color: #333333;
				padding-right: 2.8rem;
			}
			.union_box_left_sum_title{
				font-size: 3.75rem;
				font-family: GothicMB101Pro-Regular, GothicMB101Pro;
				font-weight: 400;
				color: #2A68F9;
				margin: 0;
				opacity: 0.6;
			}
			.union_box_left_sum_title_sup{
				font-size: 1.875rem;
				font-family: GothicMB101Pro-Regular, GothicMB101Pro;
				font-weight: 400;
				color: #666666;
				opacity: 0.6;
			}
			.union_box_left_sum_box{
				display: flex;
				flex-direction: column;
				align-items: baseline;
			}
			.union_box_left_sum_msg{
				font-size: 1.125rem;
				font-family: PingFangSC-Regular, PingFang SC;
				font-weight: 400;
				color: #333333;
			}
		}
	}
	.func_container{
		padding-top: 3rem;
		padding-bottom: 7rem;
		.func_list{
			width: 75rem;
			margin: 0 auto;
			padding-top: 5rem;
			display: flex;
			justify-content: space-between;
		}
		.func_box_l{
			width: 23.875rem;
			height: 27.5rem;
			background: #FFFFFF;
			box-shadow: 0 0.125rem 0.5rem 0.125rem rgba(199,199,199,0.5);
			display: flex;
			flex-direction: column;
			align-items: center;
			justify-content: space-between;
		}
		.func_box_m{
			width: 23.875rem;
			height: 27.5rem;
			display: flex;
			flex-direction: column;
			justify-content: space-between;
		}
		.func_box_m_detail{
			width: 23.875rem;
			height: 12.9375rem;
			background: #FFFFFF;
			box-shadow: 0 0.125rem 0.375rem 0.125rem rgba(212,212,212,0.5);
			display: flex;
			align-items: center;
			}
			.func_box_s{
				width: 23.875rem;
				height: 27.5rem;
				display: flex;
				flex-direction: column;
				justify-content: space-between;
			}
			.func_box_s_detail{
				width: 23.875rem;
				height: 8.125rem;
				background: #FFFFFF;
				box-shadow: 0 0.125rem 0.375rem 0.125rem rgba(212,212,212,0.5);
				display: flex;
				align-items: flex-end;
			}
			.func_msg{
				font-size: 0.9375rem;
				font-family: PingFangSC-Regular, PingFang SC;
				font-weight: 400;
				color: #666666;
				line-height: 1.3125rem;
				max-width: 16.125rem;
				padding-right: 1rem;
				
			}
			.func_title{
				font-size: 1.25rem;
				font-family: PingFang-SC-Bold, PingFang-SC;
				font-weight: bold;
				color: #333333;
				}
				.func_box_s_img{
					width: 11.5rem;
					height: 8rem;
					margin-right: 1rem;
				}
				.func_box_m_img{
					width: 9rem;
					height: 13.0625rem;
					margin-right: 1rem;
				}
				.func_box_l_img{
					width: 23.875rem;
					height: 17.6875rem;
				}
	}
</style>
